import React from 'react';

import useToast from '@/hooks/useToast';

interface Props {
    fileLength: number;
    uploadImages: { file: File; uploadSuccess: boolean }[];
    onAddFiles: (_file: File) => void;
}

const useFileAttachment = ({ uploadImages, onAddFiles, fileLength }: Props) => {
    const { openToast } = useToast();

    const handleChangeFileList = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const file = e.target.files[0];

            if (uploadImages.length >= fileLength) {
                openToast(`파일은 최대 ${fileLength}개까지 첨부 가능합니다.`);
            } else if (uploadImages.find(v => v.file.name === file.name))
                openToast('중복 파일이 있습니다. 확인해 주세요.');
            else if (file.size > 1024 * 1024 * 25) openToast(`파일은 최대 25MB까지 첨부 가능합니다.`);
            else if (!file.type.includes('image')) openToast('이미지 파일만 첨부 가능합니다.');
            else {
                onAddFiles(file);
            }
            e.target.value = '';
        } else {
            openToast('파일이 정상적으로 업로드 되지 않았습니다.', { style: { color: 'red' } });
        }
    };

    return { handleChangeFileList };
};

export default useFileAttachment;
